import React from 'react';
import { useIntl } from 'react-intl-next';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/core/migration/success--check-circle';
import { Text } from '@atlaskit/primitives';
import messages from '../../../utils/i18n/messages';
import { FlagLinkButton, FlagSeparator, FlagTitleContainer } from '../styled';
export function SuccessFlags(_ref) {
  var flags = _ref.flags,
    onDismissed = _ref.onDismissed;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: onDismissed
  }, flags.map(function (_ref2) {
    var id = _ref2.id,
      link = _ref2.link;
    return /*#__PURE__*/React.createElement(AutoDismissFlag, {
      key: id,
      id: id,
      icon: /*#__PURE__*/React.createElement(SuccessIcon, {
        label: "Success",
        color: "var(--ds-text-subtle, #44546F)",
        LEGACY_size: "medium",
        spacing: "spacious"
      }),
      title: /*#__PURE__*/React.createElement(FlagTitleContainer, null, /*#__PURE__*/React.createElement(Text, null, intl.formatMessage(messages.replySaved)), /*#__PURE__*/React.createElement(FlagSeparator, null, "\u2022"), /*#__PURE__*/React.createElement(FlagLinkButton, {
        appearance: "subtle",
        spacing: "compact",
        href: link
      }, intl.formatMessage(messages.viewReply))),
      appearance: "normal"
    });
  }));
}
export default SuccessFlags;